/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'jira-plans-efa-change-boarding': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-plans-efa-change-boarding/placements/in-app/screen-space-flags/render'
			),
	),
	'plan-calendar-create-item-spotlight': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--plan-calendar-create-item-spotlight/placements/in-app/screen-space-flags/render'
			),
	),
};
